module.exports = __webpack_public_path__ + "media/info-item-3.f170045e.mp4";